/**
 * Load More
 */

// Vendors
import $ from 'jquery';
import { scrollToElement } from '../lib/utilities';

// Prevent default when clicking on load more.
$('[data-load-more]').on('click', (event) => event.preventDefault());

$('[data-load-more]').each((index, element) => {
  const loadMoreContainer = $(element).parent();
  const loadMoreButton = $(element);

  // Bail if [data-load-more] is empty
  if (!loadMoreButton.data('load-more')) return;

  const gallery = $(`#${loadMoreButton.data('load-more')}`);

  // Bail if the load more button isn't attached to a gallery.
  if (!gallery.length) return;

  const galleryItems = gallery.children();
  const hasFeatured = !!gallery.find('.gallery-explore__item--featured').length;
  const itemsPerPage = hasFeatured ? 11 : 13;

  // Hide load more button and bail if there aren't enough items for pagination.
  if (galleryItems.length <= itemsPerPage) {
    loadMoreContainer.hide();
    return;
  }

  // Hide all but first page.
  galleryItems.each((index, element) => {
    if (index >= itemsPerPage) {
      $(element).hide();
    }
  });

  // Handle showing/hiding more items on click.
  $('[data-load-more]').on('click', (event) => {
    if (!loadMoreButton.hasClass('load-more--less')) {
      galleryItems.show();
      scrollToElement(galleryItems[itemsPerPage]);
    } else {
      galleryItems.each((index, element) => {
        if (index >= itemsPerPage) {
          $(element).hide();
        }
      });
      scrollToElement(gallery);
    }
    loadMoreButton.toggleClass('load-more--less');
  });
});
